import { useEffect, useRef } from 'react';

// heavily inspired by https://github.com/siddharthkp/use-timeout/blob/master/index.js
const useTimeout = (callback, delay) => {
  const callbackRef = useRef();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const id = window.setTimeout(() => callbackRef.current(), delay);

      return () => window.clearTimeout(id);
    }
  }, [delay]);
};

export default useTimeout;
